/**
 * Created by Prodaja1 on 12.5.2017..
 */
//import {Page} from 'ionic/ionic';
import { Component } from '@angular/core';
import {NavController} from 'ionic-angular';
import {UserData} from "../services/UserData";
import {HomePage} from '../home/home';

@Component({
    selector: 'results',
    templateUrl: 'results.html'
})


export class Results {
    userData : UserData;
    constructor(public navCtrl: NavController) {
        var navController = this.navCtrl;
        setTimeout(function(){
            navController.push(HomePage);
        }, 5000)
    }
}




// WEBPACK FOOTER //
// ./src/pages/results/results.ts